var PREFIX_SYNTAX = /^[a-z_][a-z0-9-_]*$/gi;
export default function validateSelectorPrefix() {
  var selectorPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (selectorPrefix.length > 0 && selectorPrefix.match(PREFIX_SYNTAX) === null) {
    console.error("An invalid selectorPrefix (".concat(selectorPrefix, ") has been used to create a new Fela renderer.\nIt must only contain a-Z, 0-9, - and _ while it must start with either _ or a-Z.\nSee http://fela.js.org/docs/advanced/RendererConfiguration.html"));
  }

  return selectorPrefix;
}